import { render, staticRenderFns } from "./RestrictPlatformModal.vue?vue&type=template&id=fa161638&scoped=true&"
import script from "./RestrictPlatformModal.vue?vue&type=script&lang=js&"
export * from "./RestrictPlatformModal.vue?vue&type=script&lang=js&"
import style0 from "./RestrictPlatformModal.vue?vue&type=style&index=0&id=fa161638&scoped=true&lang=css&"
import style1 from "./RestrictPlatformModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa161638",
  null
  
)

export default component.exports